const html = document.querySelector('html');

if (  navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1 &&
      navigator.userAgent.indexOf('CriOS') == -1 ) {

  if (navigator.userAgent.indexOf('iPhone') != -1) {
    html.classList.add('ios');
  }
  html.classList.add('safari');
  const vi = navigator.userAgent.indexOf('Version/') + 8;
  const version = parseFloat(navigator.userAgent.slice(vi).split(" ")[0]);
  if (version < 9) {
    html.classList.add('safari-old');
  }
  
}
if (  navigator.userAgent.indexOf('Trident') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1 &&
      navigator.userAgent.indexOf('CriOS') == -1) {
  html.classList.add('ie', 'ms');
}
if (navigator.userAgent.indexOf('Edge') != -1) {
  html.classList.add('edge', 'ms');
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/ua-sniffing.js